import { createSlice } from "@reduxjs/toolkit";
import { payment, paymentVerify } from "./PaymentAction.js";

const paymentSlice = createSlice({
  name: "Payment",
  initialState: { paymentLoading: false, paymentError: false, paymentSuccess: false, paymentDetail: {}, paymentVerifyLoading: false, paymentVerifyError: false, paymentVerifySuccess: false },
  reducers: {
    clearError: (state) => {
      state.paymentError = false;
    },
    clearSuccess: (state) => {
        state.paymentSuccess = false;
    },
    clearLoading: (state) => {
        state.paymentLoading = false;
    },
    clearPaymentVerifyError: (state) => {
      state.paymentVerifyError = false;
    },
    clearPaymentVerifySuccess: (state) => {
      state.paymentVerifySuccess = false;
    },
    clearPaymentVerifyLoading: (state) => {
      state.paymentVerifyLoading = false;
    },
    clearPaymentDetail: (state) => {
      state.paymentDetail = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(payment.pending, (state) => {
        state.paymentLoading = true;
      })
      .addCase(payment.fulfilled, (state, action) => {
        state.paymentDetail=action?.payload;
        state.paymentSuccess = true;
        state.paymentLoading = false;
        state.paymentError = false;
      })
      .addCase(payment.rejected, (state, action) => {
        state.paymentLoading = false;
        state.paymentError = true;
      })
      .addCase(paymentVerify.pending, (state) => {
        state.paymentVerifyLoading = true;
      })
      .addCase(paymentVerify.fulfilled, (state, action) => {
        state.paymentVerifySuccess = true;
        state.paymentVerifyLoading = false;
        state.paymentVerifyError = false;
      })
      .addCase(paymentVerify.rejected, (state, action) => {
        state.paymentVerifyLoading = false;
        state.paymentVerifyError = true;
      });
  },
});

const paymentAction = paymentSlice.actions;

export { paymentAction, paymentSlice };
